<template>
    <div>
        <breadcrumbs
            :title="'Vrste sudionika'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrste sudionika</h5>
                <br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Nova vrsta sudionika
                </button>
            </div>

        </div>
        <div class="ibox-content">
            <datatables
                v-if="show_datatable"
                :url="datatables_url"
                :settings="datatables.settings"
                :title="datatables.title"
                @rowClick="rowClick"
            ></datatables>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import Datatables from "../../../../components/datatable/Datatables";
import toastr from "toastr";
export default {
    name: "VrsteSudionika",
    components: { Datatables, Breadcrumbs },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL + 'vrsta-sudionika',
            datatables: {},
            breadcrumbs: []
        }
    },
    methods: {
        rowClick( row ){
            if( !row.izzy_edu_id )
                this.$router.push( { path: '/postavke/vrste-sudionika/' + row.id } )
            else
                toastr.waiting( 'Ne može se editirati' );
        },

        create(){
            this.$router.push( { path: '/postavke/vrste-sudionika/create' } )
        },

        setDatatable(){
            let vm = this

            vm.datatables = {
                settings: {
                    table_header: [
                        {
                            'id': 'id',
                            'visible': false
                        },
                        {
                            'id': 'naziv',
                            'title': 'Naziv',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'vrsta-sudionika',
                                'visible' : true
                            }
                        },
                        {
                            'id': 'izzy_edu_vrsta_sudionika',
                            'searchable': false,
                            'title': 'IzzyEdu vrsta sudionika',
                            'type' : function ( row ){
                                return row.izzy_edu_id ? 'Da' : 'Ne'
                            },
                            'column_visibility_group': {
                                'id': 'vrsta-sudionika',
                                'visible' : true
                            }
                        }
                    ],
                    column_visibility_groups:{
                        'vrsta-sudionika' : 'Vrste sudionika'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Vrste sudionika'
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-sudionika',
                    name: 'Vrste sudionika'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }

};
</script>

<style scoped>

</style>
